module.exports = __webpack_public_path__ + "static/media/Full Set.acd2987a.png";